

















import { Vue, Component, Prop, Emit, Watch } from 'vue-property-decorator'
import TranscoProductsDataTable from '../components/TranscoProductsDataTable/TranscoProductsDataTable.vue'
import store from '@/store'

@Component<TranscoProducts>({
  components: {
    'transco-products-data-table': TranscoProductsDataTable,
  },
})
export default class TranscoProducts extends Vue {
  private transcoHyperProxiDataSortBy: any

  public constructor() {
    super()
    this.transcoHyperProxiDataSortBy = ['updateDate']
  }
}
